const COUNTRY_DIAL_CODES: Record<string, string> = {
  AE: "971",
  AF: "93",
  AO: "244",
  AR: "54",
  AU: "61",
  BB: "1",
  BD: "880",
  BH: "973",
  BJ: "229",
  BF: "226",
  BO: "591",
  BR: "55",
  BS: "1",
  BW: "267",
  CA: "1",
  CL: "56",
  CI: "225",
  CM: "237",
  CN: "86",
  CO: "57",
  CR: "506",
  CU: "53",
  DO: "1",
  DZ: "213",
  EC: "593",
  EG: "20",
  ET: "251",
  FR: "33",
  GA: "241",
  GB: "44",
  GH: "233",
  GT: "502",
  HK: "852",
  HN: "504",
  ID: "62",
  IL: "972",
  IN: "91",
  IR: "98",
  IQ: "964",
  JO: "962",
  JP: "81",
  JM: "1",
  KE: "254",
  KH: "855",
  KR: "82",
  KW: "965",
  KZ: "7",
  KY: "1",
  LA: "856",
  LB: "961",
  LK: "94",
  LY: "218",
  MA: "212",
  MD: "373",
  MG: "261",
  MM: "95",
  MN: "976",
  MU: "230",
  MV: "960",
  MX: "52",
  MY: "60",
  MZ: "258",
  NA: "264",
  NI: "505",
  NG: "234",
  NP: "977",
  NZ: "64",
  OM: "968",
  PA: "507",
  PE: "51",
  PG: "675",
  PH: "63",
  PK: "92",
  PS: "970",
  PY: "595",
  QA: "974",
  RU: "7",
  RW: "250",
  SA: "966",
  SD: "249",
  SG: "65",
  SN: "221",
  SV: "503",
  SY: "963",
  TG: "228",
  TH: "66",
  TN: "216",
  TR: "90",
  TT: "1",
  TZ: "255",
  TW: "886",
  UG: "256",
  UY: "598",
  US: "1",
  UZ: "998",
  VE: "58",
  VN: "84",
  XK: "383",
  YE: "967",
  ZA: "27",
  ZM: "260",
  ZW: "263",
};

function phoneParts(phone: string) {
  return phone
    .split(/\s*(?:,|\/|;|\||\bor\b)\s*/i)
    .map((part) => part.trim())
    .filter(Boolean);
}

function normalizePhoneDigits(phone: string, country: string) {
  const trimmed = phone.trim();
  if (!trimmed || /^[-\u2013\u2014]+$/.test(trimmed)) return null;

  const dialCode = COUNTRY_DIAL_CODES[country];
  const digits = trimmed.replace(/\D/g, "");
  if (!digits) return null;

  if (trimmed.startsWith("+")) return `+${digits}`;
  if (!dialCode) return `+${digits}`;

  if (
    (country === "US" ||
      country === "CA" ||
      country === "BB" ||
      country === "BS" ||
      country === "JM" ||
      country === "KY" ||
      country === "TT") &&
    digits.length === 10
  ) {
    return `+1${digits}`;
  }

  if (country === "FR" && digits.startsWith("0")) {
    return `+33${digits.slice(1)}`;
  }

  if (country === "AU" && digits.startsWith("0")) {
    return `+61${digits.slice(1)}`;
  }

  if (country === "IN" && digits.startsWith("0")) {
    return `+91${digits.slice(1)}`;
  }

  if (country === "RU" && digits.startsWith("8") && digits.length === 11) {
    return `+7${digits.slice(1)}`;
  }

  if (country === "RU" && digits.length === 10) {
    return `+7${digits}`;
  }

  if (
    (
      [
        "AE",
        "AF",
        "AO",
        "AU",
        "BD",
        "BH",
        "BJ",
        "BF",
        "BW",
        "CI",
        "CM",
        "CN",
        "DZ",
        "EG",
        "ET",
        "GA",
        "GB",
        "GH",
        "ID",
        "IL",
        "IR",
        "IQ",
        "JO",
        "JP",
        "KE",
        "KH",
        "KR",
        "KW",
        "KZ",
        "LA",
        "LB",
        "LK",
        "LY",
        "MA",
        "MD",
        "MG",
        "MM",
        "MN",
        "MU",
        "MV",
        "MY",
        "MZ",
        "NA",
        "NG",
        "NP",
        "NZ",
        "OM",
        "PG",
        "PH",
        "PK",
        "PS",
        "QA",
        "RU",
        "RW",
        "SA",
        "SD",
        "SG",
        "SN",
        "SY",
        "TG",
        "TH",
        "TN",
        "TR",
        "TZ",
        "TW",
        "UG",
        "UZ",
        "VN",
        "XK",
        "YE",
        "ZA",
        "ZM",
        "ZW",
      ] as string[]
    ).includes(country) &&
    digits.startsWith("0")
  ) {
    return `+${dialCode}${digits.slice(1)}`;
  }

  if (digits.startsWith(dialCode)) return `+${digits}`;
  return `+${dialCode}${digits}`;
}

function formatNationalPhone(national: string, country: string) {
  if (
    (country === "US" ||
      country === "CA" ||
      country === "BB" ||
      country === "BS" ||
      country === "JM" ||
      country === "KY" ||
      country === "TT") &&
    national.length === 10
  ) {
    return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
  }

  if (country === "FR" && national.length === 9) {
    const pairs = national.slice(1).match(/.{1,2}/g) ?? [];
    return [national.slice(0, 1), ...pairs].join(" ");
  }

  if (country === "MX" && national.length === 10) {
    return `${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
  }

  if (country === "AU") {
    if (/^(?:1300|1800)\d{6}$/.test(national)) {
      return `${national.slice(0, 4)} ${national.slice(4, 7)} ${national.slice(7)}`;
    }

    if (/^[2378]\d{8}$/.test(national)) {
      return `${national.slice(0, 1)} ${national.slice(1, 5)} ${national.slice(5)}`;
    }

    if (/^0[2378]\d{8}$/.test(national)) {
      return `(${national.slice(0, 2)}) ${national.slice(2, 6)} ${national.slice(6)}`;
    }

    if (/^04\d{8}$/.test(national)) {
      return `${national.slice(0, 4)} ${national.slice(4, 7)} ${national.slice(7)}`;
    }
  }

  if (country === "IN") {
    if (/^1800\d{7}$/.test(national)) {
      return `${national.slice(0, 4)} ${national.slice(4, 7)} ${national.slice(7)}`;
    }

    if (/^1860\d{7}$/.test(national)) {
      return `${national.slice(0, 4)} ${national.slice(4, 7)} ${national.slice(7)}`;
    }

    if (/^(?:120|124|129|141|172|261|265|406|804)\d{7}$/.test(national)) {
      return `${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
    }

    if (/^[6789]\d{9}$/.test(national)) {
      return `${national.slice(0, 5)} ${national.slice(5)}`;
    }

    if (/^[2-9]\d{9}$/.test(national)) {
      return `${national.slice(0, 2)} ${national.slice(2, 6)} ${national.slice(6)}`;
    }
  }

  if (country === "JP") {
    if (/^(?:3|6)\d{8}$/.test(national)) {
      return `${national.slice(0, 1)} ${national.slice(1, 5)} ${national.slice(5)}`;
    }

    if (/^\d{2}\d{4}\d{4}$/.test(national)) {
      return `${national.slice(0, 2)} ${national.slice(2, 6)} ${national.slice(6)}`;
    }

    if (/^\d{3}\d{2,4}\d{4}$/.test(national)) {
      return `${national.slice(0, 3)} ${national.slice(3, -4)} ${national.slice(-4)}`;
    }
  }

  if (country === "KR") {
    if (/^2\d{7,8}$/.test(national)) {
      return `${national.slice(0, 1)} ${national.slice(1, -4)} ${national.slice(-4)}`;
    }

    if (/^\d{2,3}\d{3,4}\d{4}$/.test(national)) {
      return `${national.slice(0, national.length === 10 ? 2 : 3)} ${national.slice(national.length === 10 ? 2 : 3, -4)} ${national.slice(-4)}`;
    }
  }

  if (country === "CN") {
    if (/^(?:10|20|21|22|23|24|25|27|28|29)\d{8}$/.test(national)) {
      return `${national.slice(0, 2)} ${national.slice(2, 6)} ${national.slice(6)}`;
    }

    if (/^\d{3}\d{7,8}$/.test(national)) {
      return `${national.slice(0, 3)} ${national.slice(3, -4)} ${national.slice(-4)}`;
    }
  }

  if (country === "BR" && /^\d{10,11}$/.test(national)) {
    if (/^800\d{7}$/.test(national)) {
      return `${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
    }

    return `${national.slice(0, 2)} ${national.slice(2, -4)} ${national.slice(-4)}`;
  }

  if (country === "CO" && /^\d{10}$/.test(national)) {
    return `${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
  }

  if (country === "CO" && /^[1-9]\d{7}$/.test(national)) {
    return `${national.slice(0, 1)} ${national.slice(1, 4)} ${national.slice(4)}`;
  }

  if (country === "AR" && /^11\d{8}$/.test(national)) {
    return `${national.slice(0, 2)} ${national.slice(2, 6)} ${national.slice(6)}`;
  }

  if (country === "AR" && /^\d{3}\d{3,4}\d{4}$/.test(national)) {
    return `${national.slice(0, 3)} ${national.slice(3, -4)} ${national.slice(-4)}`;
  }

  if (country === "CL" && /^\d{9}$/.test(national)) {
    return `${national.slice(0, 1)} ${national.slice(1, 5)} ${national.slice(5)}`;
  }

  if (country === "CL" && /^\d{8}$/.test(national)) {
    return `${national.slice(0, 1)} ${national.slice(1, 4)} ${national.slice(4)}`;
  }

  if (country === "PE" && /^\d{9}$/.test(national)) {
    return `${national.slice(0, 1)} ${national.slice(1, 5)} ${national.slice(5)}`;
  }

  if (country === "PE" && /^\d{8}$/.test(national)) {
    return `${national.slice(0, 2)} ${national.slice(2)}`;
  }

  if (country === "NG" && /^\d{10}$/.test(national)) {
    return `${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
  }

  if (country === "RU" && /^\d{10}$/.test(national)) {
    return `${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
  }

  if (country === "PK" && /^3\d{9}$/.test(national)) {
    return `${national.slice(0, 3)} ${national.slice(3)}`;
  }

  if (country === "PK" && /^\d{9,10}$/.test(national)) {
    return `${national.slice(0, national.length === 9 ? 2 : 3)} ${national.slice(national.length === 9 ? 2 : 3)}`;
  }

  if (country === "BD" && /^1\d{9}$/.test(national)) {
    return `${national.slice(0, 4)} ${national.slice(4)}`;
  }

  if (country === "BD" && /^\d{8,10}$/.test(national)) {
    return `${national.slice(0, 2)} ${national.slice(2, 6)} ${national.slice(6)}`;
  }

  if (country === "EG" && /^\d{9,10}$/.test(national)) {
    return `${national.slice(0, 2)} ${national.slice(2, 6)} ${national.slice(6)}`;
  }

  if (country === "MA" && /^\d{9}$/.test(national)) {
    return `${national.slice(0, 1)} ${national.slice(1, 5)} ${national.slice(5)}`;
  }

  if (country === "IR" && /^\d{10,11}$/.test(national)) {
    return `${national.slice(0, national.length === 10 ? 2 : 3)} ${national.slice(national.length === 10 ? 2 : 3, 6)} ${national.slice(6)}`;
  }

  if (country === "KE" && /^\d{9}$/.test(national)) {
    return `${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
  }

  if (country === "LK" && /^\d{9}$/.test(national)) {
    return `${national.slice(0, 2)} ${national.slice(2, 5)} ${national.slice(5)}`;
  }

  if (country === "GH" && /^\d{9}$/.test(national)) {
    return `${national.slice(0, 2)} ${national.slice(2, 5)} ${national.slice(5)}`;
  }

  if (country === "NP" && /^\d{7,10}$/.test(national)) {
    return national.length <= 8
      ? `${national.slice(0, 1)} ${national.slice(1)}`
      : `${national.slice(0, 2)} ${national.slice(2, 5)} ${national.slice(5)}`;
  }

  return national.match(/.{1,4}/g)?.join(" ") ?? national;
}

export function formatPhoneWithCountryCode(
  phone: string | null | undefined,
  country: string | null | undefined,
) {
  if (!phone || !country) return null;
  const dialCode = COUNTRY_DIAL_CODES[country];

  const formatted = phoneParts(phone)
    .map((part) => {
      const normalized = normalizePhoneDigits(part, country);
      if (!normalized) return null;

      if (!dialCode || !normalized.startsWith(`+${dialCode}`)) {
        return normalized;
      }

      const national = normalized.slice(dialCode.length + 1);
      return `+${dialCode} ${formatNationalPhone(national, country)}`;
    })
    .filter(Boolean);

  return formatted.length > 0 ? formatted.join(" / ") : null;
}

export function getPhoneHref(
  phone: string | null | undefined,
  country: string | null | undefined,
) {
  if (!phone || !country) return undefined;
  const firstPhone = phoneParts(phone)[0];
  const normalized = firstPhone
    ? normalizePhoneDigits(firstPhone, country)
    : null;
  return normalized ? `tel:${normalized}` : undefined;
}

export function getClinicPhoneContact(
  phone: string | null | undefined,
  country: string | null | undefined,
) {
  const display = formatPhoneWithCountryCode(phone, country);
  const href = getPhoneHref(phone, country);
  return display && href ? { display, href } : null;
}
